module.exports = __webpack_public_path__ + "image/wx-icon.png";